/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Drastic_Tech_Process_Error_LogInputs */

const en_drastic_tech_process_error_log = /** @type {(inputs: Drastic_Tech_Process_Error_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC error]: ${i?.error}`)
};

const fr_drastic_tech_process_error_log = /** @type {(inputs: Drastic_Tech_Process_Error_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC erreur] : ${i?.error}`)
};

const de_drastic_tech_process_error_log = /** @type {(inputs: Drastic_Tech_Process_Error_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRAMATIVER Fehler]: ${i?.error}`)
};

const it_drastic_tech_process_error_log = /** @type {(inputs: Drastic_Tech_Process_Error_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[Errore DRASTICO]: ${i?.error}`)
};

const ru_drastic_tech_process_error_log = /** @type {(inputs: Drastic_Tech_Process_Error_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[КРИСТАЛЬНАЯ ошибка]: ${i?.error}`)
};

const es_drastic_tech_process_error_log = /** @type {(inputs: Drastic_Tech_Process_Error_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[Error DRÁSTICO]: ${i?.error}`)
};

const zh_cn2_drastic_tech_process_error_log = /** @type {(inputs: Drastic_Tech_Process_Error_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[严重错误]: ${i?.error}`)
};

const ja_drastic_tech_process_error_log = /** @type {(inputs: Drastic_Tech_Process_Error_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[重大なエラー]: ${i?.error}`)
};

const hi_drastic_tech_process_error_log = /** @type {(inputs: Drastic_Tech_Process_Error_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[गंभीर त्रुटि]: ${i?.error}`)
};

const pt_pt2_drastic_tech_process_error_log = /** @type {(inputs: Drastic_Tech_Process_Error_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[Erro DRASTIC]: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "[DRASTIC error]: {error}" |
*
* @param {Drastic_Tech_Process_Error_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_process_error_log = /** @type {((inputs: Drastic_Tech_Process_Error_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Process_Error_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_process_error_log(inputs)
	if (locale === "de") return de_drastic_tech_process_error_log(inputs)
	if (locale === "it") return it_drastic_tech_process_error_log(inputs)
	if (locale === "ru") return ru_drastic_tech_process_error_log(inputs)
	if (locale === "es") return es_drastic_tech_process_error_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_process_error_log(inputs)
	if (locale === "ja") return ja_drastic_tech_process_error_log(inputs)
	if (locale === "hi") return hi_drastic_tech_process_error_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_process_error_log(inputs)
	return en_drastic_tech_process_error_log(inputs)
});